import React, { useEffect, useState } from 'react';
import { Table, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../Config/axiosConfig';
import getClassPublishedColumns from '../../Config/getClassPublishedColumns';
import UpdateClassModal from '../UpdateClassModal/UpdateClassModal';

function Published() {
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedClass, setSelectedClass] = useState(null);
  const navigate = useNavigate();

  const fetchClasses = async (page = 1, pageSize = 10) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post('/Public/get-paged-classes', {
        pageNumber: page,
        pageSize: pageSize,
      });

      const { data } = response?.data;
      if (data && Array.isArray(data.classes)) {
        setClasses(data.classes);
        setPagination({
          current: page,
          pageSize: pageSize,
          total: data.totalCount || data.pages * pageSize || 0,
        });
      } else {
        message.error('No class data received.');
        setClasses([]);
      }
    } catch (error) {
      console.error('Error fetching classes:', error);
      message.error('Error fetching classes');
      setClasses([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchClasses(pagination.current, pagination.pageSize);
  }, []);

  const handleTableChange = (newPagination) => {
    const { current, pageSize } = newPagination;
    fetchClasses(current, pageSize);
  };

  const handleRowClick = (record) => {
    navigate(`/preview-class/${record.id}`);
  };

  const handleEditClass = (record) => {
    setSelectedClass(record);
    setIsModalVisible(true);
  };

  const handleUpdateSuccess = () => {
    fetchClasses(pagination.current, pagination.pageSize);
  };

  const columns = getClassPublishedColumns(
    navigate,
    () => fetchClasses(pagination.current, pagination.pageSize),
    pagination.current,
    handleEditClass
  );

  return (
    <div className="admin-classes" style={{ padding: '20px' }}>
      <h2>Published Classes</h2>
      <Table
        columns={columns}
        dataSource={classes}
        rowKey="id"
        loading={loading}
        pagination={{
          ...pagination,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50', '100'],
        }}
        onChange={handleTableChange}
        onRow={(record) => ({
          onClick: () => handleRowClick(record),
        })}
        scroll={{ x: 'max-content' }}
        bordered
      />

      <UpdateClassModal
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        classInfo={selectedClass}
        onUpdateSuccess={handleUpdateSuccess}
      />
    </div>
  );
}

export default Published;
